function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { closePinModal, getChannelSettings, setProfileSettings } from "@common/actions";
import { LOCK_PERIODS } from "@common/constants";
import { isMobile, setSessionLockTime } from "@common/services/helpers";
import { changeWebSetting } from "@common/utils/helpers";
import { KEY_ESCAPE, SNACKBAR_AUTOHIDE_TIMEOUT, SNACKBAR_VARIANT_ERROR, SNACKBAR_VARIANT_SUCCESS } from "@config/constants";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Typography from "@material-ui/core/Typography";
import { isEmpty, isEqual, isNil } from "lodash";
import { withSnackbar } from "notistack";
import React from "react";
import PinInput from "react-pin-input";
import { connect } from "react-redux";
var PinModal = /*#__PURE__*/ function(_React_PureComponent) {
    "use strict";
    _inherits(PinModal, _React_PureComponent);
    var _super = _create_super(PinModal);
    function PinModal(props) {
        _class_call_check(this, PinModal);
        var _this;
        _this = _super.call(this, props);
        /**
     * Sets ref on the modal wrapper
     * @param {Object} node
     */ _define_property(_assert_this_initialized(_this), "setWrapperRef", function(node) {
            _this.wrapperRef = node;
        });
        _define_property(_assert_this_initialized(_this), "autoFocus", function() {
            // Schedule in a timeout for async focus
            setTimeout(function(_) {
                var inputRef = _this.inputRef.current;
                if (!inputRef) {
                    return;
                }
                var lastEnteredIndex = inputRef.values.findIndex(function(e) {
                    return isNil(e) || e === "";
                });
                inputRef.elements[lastEnteredIndex].focus();
            // this.inputRef.current.focus()
            });
        });
        _define_property(_assert_this_initialized(_this), "handleOnChange", function(value, index) {
            // Handle focus to be on the first element
            var pinInput = _this.inputRef.current;
            if (value.length < index) {
                pinInput.clear();
                pinInput.focus();
            }
            _this.setState({
                pin: value
            });
        });
        _define_property(_assert_this_initialized(_this), "showSuccessMessage", function() {
            var _this_props = _this.props, _this_props_shouldShowSnackbar = _this_props.shouldShowSnackbar, shouldShowSnackbar = _this_props_shouldShowSnackbar === void 0 ? true : _this_props_shouldShowSnackbar;
            if (!shouldShowSnackbar) {
                return;
            }
            _this.props.enqueueSnackbar(_this.props.i18n.settings.unlockChannels, {
                variant: SNACKBAR_VARIANT_SUCCESS,
                autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT
            });
        });
        _define_property(_assert_this_initialized(_this), "showErrorMessage", function(onExited) {
            return _this.props.enqueueSnackbar(_this.props.i18n.settings.PINFail, {
                variant: SNACKBAR_VARIANT_ERROR,
                autoHideDuration: SNACKBAR_AUTOHIDE_TIMEOUT,
                style: {
                    paddingBottom: isMobile.any() ? "72px" : "16px"
                },
                onExited: onExited
            });
        });
        _define_property(_assert_this_initialized(_this), "getTimeToLockChannels", function() {
            var profileSettings = _this.props.profileSettings;
            var lockPeriod = profileSettings.web_settings.lockPeriod;
            switch(lockPeriod){
                case LOCK_PERIODS.ALWAYS_LOCK:
                    return null;
                case LOCK_PERIODS.SESSION_LOCK:
                    // Set session storage
                    setSessionLockTime(Number.POSITIVE_INFINITY, true);
                    return Number.POSITIVE_INFINITY;
                default:
                    var newTime = Date.now() + lockPeriod;
                    setSessionLockTime(newTime);
                    return newTime;
            }
        });
        var _this1 = _assert_this_initialized(_this);
        _define_property(_assert_this_initialized(_this), "handleUnlock", /*#__PURE__*/ _async_to_generator(function() {
            var _this_props, profileSettings, _$setProfileSettings, timeToLockChannels, newProfileSettings;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _this_props = _this1.props, profileSettings = _this_props.profileSettings, _$setProfileSettings = _this_props.setProfileSettings;
                        // Increment time to lock channels in store
                        timeToLockChannels = _this1.getTimeToLockChannels();
                        newProfileSettings = changeWebSetting(profileSettings, {
                            timeToLockChannels: timeToLockChannels
                        });
                        return [
                            4,
                            _$setProfileSettings(newProfileSettings)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        }));
        var _this2 = _assert_this_initialized(_this);
        _define_property(_assert_this_initialized(_this), "handleOnComplete", function() {
            var _ref = _async_to_generator(function(value, _) {
                var _this_props, settingsChannelsConfig, _$closePinModal, onSuccess, _this_props_shouldCloseModal, shouldCloseModal, _this_props_shouldUnlock, shouldUnlock, lockedPIN, defaultPIN, pin, pinInput, currentPin, _tmp;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this_props = _this2.props, settingsChannelsConfig = _this_props.settingsChannelsConfig, _$closePinModal = _this_props.closePinModal, onSuccess = _this_props.onSuccess, _this_props_shouldCloseModal = _this_props.shouldCloseModal, shouldCloseModal = _this_props_shouldCloseModal === void 0 ? true : _this_props_shouldCloseModal, _this_props_shouldUnlock = _this_props.shouldUnlock, shouldUnlock = _this_props_shouldUnlock === void 0 ? true : _this_props_shouldUnlock;
                            lockedPIN = settingsChannelsConfig.lockedPIN, defaultPIN = settingsChannelsConfig.defaultPIN;
                            pin = _this2.state.pin;
                            pinInput = _this2.inputRef.current;
                            currentPin = lockedPIN || defaultPIN;
                            if (!isEqual(currentPin, pin)) return [
                                3,
                                3
                            ];
                            _this2.showSuccessMessage();
                            _tmp = shouldUnlock;
                            if (!_tmp) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                _this2.handleUnlock()
                            ];
                        case 1:
                            _tmp = _state.sent();
                            _state.label = 2;
                        case 2:
                            _tmp;
                            onSuccess && onSuccess();
                            shouldCloseModal && _$closePinModal();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            _this2.showErrorMessage(_this2.autoFocus);
                            _this2.setState({
                                pin: undefined
                            });
                            pinInput === null || pinInput === void 0 ? void 0 : pinInput.clear();
                            _this2.autoFocus();
                            _state.label = 4;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(value, _) {
                return _ref.apply(this, arguments);
            };
        }());
        /**
     * Closes the modal on click outside of the modal wrapper
     * @param {Object} event
     */ _define_property(_assert_this_initialized(_this), "handleClickOutside", function(event) {
            if (_this.wrapperRef && !_this.wrapperRef.contains(event.target)) {
                _this.props.closePinModal();
            }
        });
        /**
     * Closes the modal on escape keydown
     * @param {Object} event
     */ _define_property(_assert_this_initialized(_this), "closeFromKeyboard", function(event) {
            var key = event.which;
            if (key === KEY_ESCAPE) {
                event.stopPropagation();
                _this.props.closePinModal();
            }
        });
        _define_property(_assert_this_initialized(_this), "renderPinInput", function() {
            var defaultStyle = {
                borderColor: "#666",
                backgroundColor: "#f1f1f1",
                borderRadius: 4,
                borderWidth: 2,
                width: 36,
                height: 46
            };
            var focusStyle = {
                color: "#1f9cd7",
                borderColor: "#1f9cd7",
                boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.25)"
            };
            var containerStyle = {
                padding: "32px 42px",
                borderRadius: 4,
                boxShadow: "inset 0 4px 7px 0 rgba(0, 0, 0, 0.05)",
                border: "solid 1px #f1f1f1",
                backgroundColor: "#fbfbfb"
            };
            return /*#__PURE__*/ _jsx(PinInput, {
                ref: function(n) {
                    return _this.inputRef.current = n;
                },
                length: 4,
                initialValue: "",
                secret: true,
                onChange: _this.handleOnChange,
                onComplete: _this.handleOnComplete,
                type: "password",
                inputMode: "numeric",
                focus: true,
                autoSelect: true,
                style: containerStyle,
                inputStyle: defaultStyle,
                inputFocusStyle: _object_spread({}, defaultStyle, focusStyle),
                regexCriteria: /^[0-9]*$/
            });
        });
        _define_property(_assert_this_initialized(_this), "renderCloseButton", function() {
            var _$closePinModal = _this.props.closePinModal;
            var style = {
                position: "relative",
                top: 0,
                right: 0,
                fontSize: "1.5rem"
            };
            return /*#__PURE__*/ _jsx("span", {
                onClick: _$closePinModal,
                style: style,
                className: "icon icon-clear pointer"
            });
        });
        _define_property(_assert_this_initialized(_this), "renderUnlockButton", function() {
            var i18n = _this.props.i18n;
            return /*#__PURE__*/ _jsxs(Button, {
                className: "button raised",
                onClick: _this.saveProfileSettings,
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "icon isa-icon isa_parental"
                    }),
                    i18n.pin.unlock
                ]
            });
        });
        _define_property(_assert_this_initialized(_this), "renderTitle", function() {
            var i18n = _this.props.i18n;
            return /*#__PURE__*/ _jsx(Typography, {
                className: "title",
                component: "div",
                children: i18n.pin.title
            });
        });
        _this.inputRef = /*#__PURE__*/ React.createRef();
        _this.wrapperRef = null;
        _this.state = {
            pin: undefined
        };
        _this.pinModalStyle = {
            overflow: "hidden",
            position: "fixed",
            width: "100%",
            height: "100%"
        };
        return _this;
    }
    _create_class(PinModal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this_props = this.props, settingsChannelsConfig = _this_props.settingsChannelsConfig, _$getChannelSettings = _this_props.getChannelSettings;
                document.addEventListener("mousedown", this.handleClickOutside);
                document.body.style.overflow = "hidden";
                document.body.style["touchAction"] = "none";
                this.wrapperRef.focus();
                // Auto focus on first input element
                this.autoFocus();
                //
                isEmpty(settingsChannelsConfig) && _$getChannelSettings();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("mousedown", this.handleClickOutside);
                document.body.style.overflow = "";
                document.body.style["touchAction"] = "";
            }
        },
        {
            key: "render",
            value: function render() {
                var i18n = this.props.i18n;
                return /*#__PURE__*/ _jsx("div", {
                    className: "modal-overlay",
                    onKeyDown: this.closeFromKeyboard,
                    style: this.pinModalStyle,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "pin-modal-overlay",
                        tabIndex: "0",
                        ref: this.setWrapperRef,
                        children: /*#__PURE__*/ _jsxs(Card, {
                            style: {
                                width: 345
                            },
                            children: [
                                /*#__PURE__*/ _jsx(CardHeader, {
                                    // title={this.renderTitle()}
                                    action: this.renderCloseButton(),
                                    style: {
                                        paddingBottom: 0
                                    }
                                }),
                                /*#__PURE__*/ _jsxs(CardContent, {
                                    style: {
                                        display: "flex",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                        padding: "0 40px 30px"
                                    },
                                    children: [
                                        this.renderTitle(),
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: "h5",
                                            className: "subtitle",
                                            color: "text.secondary",
                                            children: i18n.pin.pleaseEnterPin
                                        }),
                                        this.renderPinInput()
                                    ]
                                })
                            ]
                        })
                    })
                });
            }
        }
    ]);
    return PinModal;
}(React.PureComponent);
var mapStateToProps = function(param) {
    var i18n = param.i18n, profileSettings = param.profileSettings, settingsChannelsConfig = param.settingsChannelsConfig;
    return {
        i18n: i18n,
        profileSettings: profileSettings,
        settingsChannelsConfig: settingsChannelsConfig
    };
};
export default withSnackbar(connect(mapStateToProps, {
    closePinModal: closePinModal,
    getChannelSettings: getChannelSettings,
    setProfileSettings: setProfileSettings
})(PinModal));
